/**
 * @generated SignedSource<<c2afe7dcb2588adba9405090f76575c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type declineReason_softwareReleasesApprovers$data = {
  readonly declineReason: string | null | undefined;
  readonly id: string;
  readonly user: {
    readonly accountId: string;
  };
  readonly " $fragmentType": "declineReason_softwareReleasesApprovers";
};
export type declineReason_softwareReleasesApprovers$key = {
  readonly " $data"?: declineReason_softwareReleasesApprovers$data;
  readonly " $fragmentSpreads": FragmentRefs<"declineReason_softwareReleasesApprovers">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "declineReason_softwareReleasesApprovers",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "ScalarField",
      "name": "declineReason"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "accountId"
            },
            "action": "THROW",
            "path": "user.accountId"
          }
        ]
      },
      "action": "THROW",
      "path": "user"
    }
  ],
  "type": "JiraVersionApprover"
};

(node as any).hash = "9a9ae7f6ce65233c8a8a317185c80c40";

export default node;
